import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { renderMarkdown } from 'common/utils/helpers';

function ResultsSummaryConclusion(props) {
  const { conclusion, multiPagesDisplay } = props;

  if (!conclusion) return null;

  return (
    <div className={classNames('results-summary-conclusion', { 'no-border': multiPagesDisplay })}>
      <div className="markdown" dangerouslySetInnerHTML={{ __html: renderMarkdown(conclusion) }} />
    </div>
  );
}

ResultsSummaryConclusion.propTypes = {
  conclusion: PropTypes.string,
  multiPagesDisplay: PropTypes.bool,
};

ResultsSummaryConclusion.defaultProps = {
  conclusion: undefined,
  multiPagesDisplay: false,
};

export default ResultsSummaryConclusion;
